import { Button, Card, Modal, Progress, Steps, Tag, Tooltip, Typography, message } from "antd"

import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { FireOutlined, PlusCircleOutlined, RocketOutlined, SearchOutlined, ShopFilled } from "@ant-design/icons";
import { useAuth } from "../../../../../store/AuthContext/AuthContext";
import { useFetch } from "../../../../../hooks/useFetch/useFetch";
import { KeywordResultCreated, KeywordResultDistance, KeywordResultDistanceLocalpack, KeywordResultKeyword, KeywordResultLocalpack, KeywordResultRankings } from "../_common/GridComponents";
import { ButtonLZ } from "../../../../components/design/Buttons/ButtonLZ";
import TableLZM from "../../../../components/design/table/TableLZM";
import { LeadModal } from "./drawer/LeadModal";
import { PlaceKWDrawer } from "../../pageLocations/Drawer/PlaceKWDrawer";
import { NewPlaceGeogridModal } from "./drawer/NewPlaceGeogridModal";
import { CompetitorsMapModal } from "../_drawers/CompetitorsMapModal";
import { Place } from "../../../../components/model/business/FieldsGroup";
import { GeogridPlaceDrawer } from "./drawer/GeogridPlaceDrawer";
import { TableFilter } from "../../../../../common/utils/FilterUtils";
import { EmptyStateBox } from "../../../../components/design/EmptyStateBox/EmptyStateBox";

export const Leads = (props: {selectedType: any}) => {
	
	const [newPlaceModal, setNewPlaceModal] = useState<boolean>(false);
	const [newPlaceScan, setNewPlaceScan] = useState<any>(null);
	const [placeKeywordsDrawer, setPlaceKeywordsDrawer] = useState(null);	
	const [competitorsModal, setCompetitorsModal] = useState(null);	
	const [rankingsModal, setRankingsModal] = useState<any>(null);	
	const [updateData, setUpdateData] = useState(false);	
	
	const [places, setPlaces] = useState<any>(null);    
	
	const { projectGroup } = useAuth();
    const { t } = useTranslation();
	
	useFetch(`${process.env.REACT_APP_API}/projects/${projectGroup.project}/keywords/places?periodOpt=${props.selectedType}`,
		{},
		[updateData],
		(data) => {
			setPlaces(data);      
		}
	); 

	const COLUMNS: any = [		
		{
			title: 'Lead',
			key: 'title',			
			width: '350px',
			filterDropdown: TableFilter,
			onFilter: (value: any, record: any) => record.place?.title.includes(value),
      		sorter: (a: any, b: any) => a.place?.title.localeCompare(b.place?.title),	
			render: (text: string, record: any) => (										
				<Place place={record.place} onClick={() => {setPlaceKeywordsDrawer(record.place)}}/>
			)			
		},
		{
			title: 'Keywords',
			key: 'keywords',						
			render: (text: string, record: any) => (										
				<>
                    <div style={{display: 'grid', gridTemplateColumns: '150px 80px 1fr 1fr 1fr 1fr 50px', columnGap: '20px', rowGap: '6px', alignItems: 'center'}}>
					{record.keywordPlaceMetrics?.map((metric: any, index: number)=>{
						return <>
								<KeywordResultKeyword keyword={metric.keyword} scope={metric.scope}/>	
								<KeywordResultDistanceLocalpack metric={metric} onClick={() => {setCompetitorsModal(metric.geogridId)}}/>				
								<KeywordResultDistance metric={metric}/>				
								<KeywordResultLocalpack metric={metric}/>								
								<KeywordResultRankings metric={metric} onClick={() => {setRankingsModal({place: record.place, keyword: metric.keyword})}}/>								
								<KeywordResultCreated metric={metric}/>
								<Tooltip title={<div>Nuevo escaneo</div>}>
									<div>
										<ButtonLZ size='small' onClick={() => {setNewPlaceScan({id: record.place?.id, kw: metric.keyword})}} type='primary'>
											<RocketOutlined/>
										</ButtonLZ>
									</div>
								</Tooltip>
							</>
                        })
                    }   
					</div>
					{                
            }     
				</>
			)			
		}
	]

    return (
		<>                    
			<div style={{display:'flex', color:'slategray', justifyContent:'flex-end', alignItems:'center', marginRight:'20px'}}>									
				<ButtonLZ size='small' onClick={() => {setNewPlaceModal(true)}} type='ghost'>
					<PlusCircleOutlined/> Nuevo Lead
				</ButtonLZ>  					
			</div>		

			{places && !places.length ? (
				<div style={{ margin: '20px 0' }}>
					<EmptyStateBox
						icon={<ShopFilled />}
						title="No hay leads"
						description="Añade un nuevo lead para empezar a monitorizar su visibilidad."
					/>
				</div>
			) : places ? (
				<TableLZM					
				rowKey='cid'
				columns={COLUMNS}
				dataSource={places}/>
			) : null}						

			{ newPlaceModal && <LeadModal benchmarkMap={newPlaceModal} onFinish={() => {setNewPlaceModal(false); setUpdateData(!updateData)}}/> }
			{ placeKeywordsDrawer && <PlaceKWDrawer place={placeKeywordsDrawer} onFinish={() => {setPlaceKeywordsDrawer(null); setUpdateData(!updateData)}}/> }
			{ newPlaceScan && <NewPlaceGeogridModal id={newPlaceScan.id} keyword={newPlaceScan.kw} onFinish={() => {setNewPlaceScan(null); setUpdateData(!updateData)}} onClose={() => {setNewPlaceScan(null);}}/>}			 
			{ competitorsModal && <CompetitorsMapModal geogridId={competitorsModal} onClose={() => {setCompetitorsModal(null)}}/> }
			{ rankingsModal && <GeogridPlaceDrawer place={rankingsModal.place} keyword={rankingsModal.keyword} onFinish={() => {setRankingsModal(null)}}/> }			
		</>
    )	
}
